export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-arubaid.svg?31aa720a124dc2c8902d7f24eda84f06";